import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';

import {Float, FloatBack} from './common';
import BtnYES from 'url:../images/btn-yes.svg';
import BtnNO from 'url:../images/btn-no.svg';

export default ({test, limit, doNext, doSave, doCancel}) => {
    const [timer, setTimer] = useState(limit);
    const [index, setIndex] = useState(0);
    const [confirm_end, setConfirmEnd] = useState(false);
    const [modal, setModal] = useState(false);
    const [collect, setCollect] = useState(false);
    const [harryUp, setHarryUp] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(
            () => {
                const tm = timer - 1;
                if ( tm == 30 ) {
                    setHarryUp(true);
                }
                if ( tm == 0 ) {
                    setConfirmEnd(true);
                    doCancel();
                    return;
                }
                setTimer(tm);
            }
        , 1000);
        return () => clearTimeout(timeout);
    }, [timer]);

  const select = (answer) => {
    doSave(answer);
    if ( test.answer == answer ) {
        setCollect(true);
    } else {
        setCollect(false);
    }
    setModal(true);
  }

    return (
        <FloatBack>
            {confirm_end &&
            <Float>
                <div css={css`
                    background-color: #fff;
                    padding: 40px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    @media screen and (max-width: 720px) {
                        padding: 20px;
                    }
                `}>
                <p css={css`font-size: 24px; margin: 0 0 10px;`}>
                    回答時間が過ぎました
                </p>
                <Link to="/">ホームへ戻る</Link>
                </div>
            </Float>
            }

            {modal &&
            <Float>
            <div css={css`
                background-color: #fff;
                padding: 40px;
                display: flex;
                flex-direction: column;
                align-items: center;
                @media screen and (max-width: 720px) {
                    padding: 20px;
                }
            `}>
                <div css={css`font-size: 24px;margin: 0 0 30px;`}>{collect ? "正解！" : <>正解は、<span>{test.answer == 'yes' ? '○' : '×'}</span></>}</div>
                <p css={css`margin: 0 0 30px;`}>
                {test.explain}
                </p>
                <span css={css`
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
                `} onClick={() => doNext()}>続きを見る</span>
            </div>
            </Float>}

            {!confirm_end && ! modal &&
            <Float>
              <div css={css`
                  background-color: #fff;
                  padding: 40px;
                  @media screen and (max-width: 720px) {
                      padding: 20px;
                  }
              `}>
                  <div css={css`display: flex; justify-content: space-between; align-items: center;`}>
                      <p css={css`font-size: 24px; margin: 0 0 20px;`}>確認問題</p>
                      <p css={css`margin: 0 0 20px; ${harryUp && `color: #f00`}`}>残り <span>{timer}</span>秒</p>
                  </div>
                  <div css={css`color: #f00; font-size: 12px; margin: 0 0 20px;`}>
                      未回答のまま1分間放置されますと、受講されていないと判断され、動画は中断となります。<br/>
                      最初から受講しなおしとなりますのでご注意ください
                  </div>
                  <div css={css`margin: 0 0 40px;`}>
                      {test.question}
                  </div>
                  <div css={css`
                      display: flex; justify-content: flex-end;
                      @media screen and (max-width: 720px) {
                          justify-content: center;
                      }
                  `}>
                      <span css={css`margin-right: 20px; cursor: pointer;`} onClick={() => select('yes')}><img src={BtnYES} width="45" height="45"/></span>
                      <span css={css`cursor: pointer;`} onClick={() => select('no')}><img src={BtnNO} width="45" height="45"/></span>
                  </div>
              </div>
            </Float>
            }
        </FloatBack>
    );
}
